import { inject, NgModule } from "@angular/core";
import { ActivatedRouteSnapshot, RouterModule, Routes } from "@angular/router";
import {
  AuthorizeGuard,
  DefaultRoomGuard,
  RoomInvitationFirstGuard
} from "./guards";

const routes: Routes = [
  {
    path: ":roomId",
    runGuardsAndResolvers: "always",
    loadChildren: () =>
      import("./modules/room/room.module").then((m) => m.RoomModule),
    canActivate: [
      (route: ActivatedRouteSnapshot) =>
        inject(RoomInvitationFirstGuard).canActivate(route),
      (route: ActivatedRouteSnapshot) =>
        inject(AuthorizeGuard).canActivate(route)
    ],
    pathMatch: "full"
  },
  {
    path: ":roomId/live-view",
    runGuardsAndResolvers: "always",
    loadChildren: () =>
      import("@youm-front/room/feature/live-view").then(
        (_) => _.RoomFeatureLiveViewModule
      ),
    canActivate: [
      (route: ActivatedRouteSnapshot) =>
        inject(AuthorizeGuard).canActivate(route)
    ],
    pathMatch: "full"
  },
  {
    path: ":roomId/invitation",
    runGuardsAndResolvers: "always",
    loadChildren: () =>
      import("./modules/invitation/invitation.module").then(
        (m) => m.InvitationModule
      ),
    pathMatch: "full"
  },
  {
    path: ":roomId/webcast-mcu-viewer",
    runGuardsAndResolvers: "always",
    loadChildren: () =>
      import("@youm-front/room/feature/webcast-mcu-viewer").then(
        (_) => _.WebcastMcuViewerModule
      ),
    canActivate: [
      (route: ActivatedRouteSnapshot) =>
        inject(AuthorizeGuard).canActivate(route)
    ],
    pathMatch: "full"
  },
  {
    path: "**",
    canActivate: [() => inject(DefaultRoomGuard).canActivate()],
    children: []
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
